var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"0px"}},[_c('div',{staticClass:"container"},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.img,"fit":"contain"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }